import type { DaySchedule } from "../data/schedule";
import { T } from "../styles/theme";

interface DayHeaderCardProps {
  activeDay: string;
  dayData: DaySchedule;
  done: number;
  total: number;
  pct: number;
  allDone: boolean;
}

/** Title card showing the active day's emoji, theme, and a progress bar. */
export function DayHeaderCard({ activeDay, dayData, done, total, pct, allDone }: DayHeaderCardProps) {
  return (
    <div
      style={{
        background: T.white,
        borderRadius: 20,
        padding: "16px 18px 14px",
        marginBottom: 12,
        boxShadow: "0 2px 16px rgba(107,63,160,0.1)",
        border: "1px solid #ece4f8",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <span style={{ fontSize: 24 }}>{dayData.emoji}</span>
          <h2
            style={{
              margin: "3px 0 0",
              fontSize: 21,
              color: "#3d1e5c",
              fontFamily: T.display,
              fontWeight: 700,
              letterSpacing: -0.3,
            }}
          >
            {activeDay}
          </h2>
          <div style={{ fontSize: 11, color: "#a05a8b", fontStyle: "italic", marginTop: 1 }}>{dayData.theme}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              fontSize: 34,
              fontWeight: 800,
              color: allDone ? "#6db87a" : "#a05a8b",
              lineHeight: 1,
              fontFamily: T.display,
            }}
          >
            {pct}%
          </div>
          <div style={{ fontSize: 10, color: T.inkLight, letterSpacing: 0.5, marginTop: 2 }}>
            {done} of {total} done
          </div>
        </div>
      </div>
      <div style={{ marginTop: 12, height: 7, background: "#ece4f8", borderRadius: 99, overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            background: allDone
              ? "linear-gradient(90deg,#6db87a,#4caf66)"
              : "linear-gradient(90deg,#6b3fa0,#c8834a)",
            borderRadius: 99,
            transition: "width 0.5s ease",
          }}
        />
      </div>
      {allDone && (
        <div
          style={{
            marginTop: 9,
            textAlign: "center",
            fontSize: 12,
            color: "#4caf66",
            fontWeight: 600,
            fontStyle: "italic",
          }}
        >
          🎉 You showed up and showed out today, sis!
        </div>
      )}
    </div>
  );
}
